import { React, classNames, withStyles, StyledProps, _ } from '@api'
import { TextInput } from './'
import { Theme } from '@material-ui/core'

const styles = (theme: Theme) => ({
  inputDisabled: {
    color: 'rgba(27, 27, 27, 0.87)',
    fontSize: 14,
    '&:before': {
      borderBottom: '0 !important'
    }
  }
})

interface DisplayName {
  singular?: string
  plural?: string
}

interface TypeData {
  name?: string,
  displayName?: DisplayName
}

interface MyProps extends StyledProps {
  label: string,
  data?: TypeData
}

@(withStyles as any)(styles)
export class Type extends React.Component<MyProps> {
  render() {
    const {label, data, classes} = this.props
    const value = data ? (data.displayName && !_.isEmpty(data.displayName.singular) ? data.displayName.singular : (data.name ? data.name : '--')) : '--'

    return (
      <TextInput
        label={label ? label : ''}
        value={value}
        InputProps={{
          classes: {disabled: classes.inputDisabled}
        }}
        disabled
        placeholder={`Enter ${label}`}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Type.tsx